import { classifyError } from './errors'
import { toastError } from './toast'

// Wraps a Firestore mutation (or any async operation) with the standard
// "show error toast and rethrow" pattern. The fn is responsible for any
// analytics tracking on success — keep track() inside fn so result-dependent
// params (e.g. a new doc id) stay straightforward.
export async function runMutation<T>(
  errorLabel: string,
  fn: () => Promise<T>,
): Promise<T> {
  try {
    return await fn()
  } catch (err) {
    toastError(errorLabel, classifyError(err))
    throw err
  }
}
